import React from "react";
import { ISSUE_TYPE_LABELS, IssueType } from "./types";

interface TypeIconProps {
  type: IssueType;
}

// The issue-type glyph (square/check, bug, bookmark, chore lines, epic bolt) inside its tinted square.
// Shared by the kanban card, the list view, and the backlog so the type reads the same everywhere —
// previously only the card drew the glyph and the other views showed an empty colored square.
const TypeIcon: React.FC<TypeIconProps> = ({ type }) => {
  const label: string = ISSUE_TYPE_LABELS[type];
  let path: React.ReactNode = null;
  switch (type) {
    case "task":
      // Square with check
      path = (
        <>
          <rect x="3" y="3" width="14" height="14" rx="2" fill="none" stroke="currentColor" />
          <path
            d="M6.5 10.5 L9 13 L13.5 7.5"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
      break;
    case "bug":
      // Bug body
      path = (
        <>
          <rect x="6" y="6" width="8" height="10" rx="4" fill="currentColor" />
          <path
            d="M10 4 V6 M5 8 L3.5 7 M5 12 H3.5 M5 16 L3.5 17 M15 8 L16.5 7 M15 12 H16.5 M15 16 L16.5 17"
            stroke="currentColor"
            strokeLinecap="round"
          />
        </>
      );
      break;
    case "feature":
      // Bookmark
      path = <path d="M6 3 H14 V17 L10 14 L6 17 Z" fill="currentColor" strokeLinejoin="round" />;
      break;
    case "chore":
      // Wrench / horizontal lines
      path = (
        <>
          <line x1="4" y1="6.5" x2="16" y2="6.5" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
          <line x1="4" y1="10" x2="13" y2="10" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
          <line x1="4" y1="13.5" x2="14" y2="13.5" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
        </>
      );
      break;
    case "epic":
      // Diamond / lightning
      path = <path d="M11 2 L5 11 H9 L7 18 L15 9 H11 L13 2 Z" fill="currentColor" strokeLinejoin="round" />;
      break;
  }
  return (
    <span
      className={`kuika-board__type-icon kuika-board__type-icon--${type}`}
      title={label}
      aria-label={`Issue type ${label}`}
    >
      <svg viewBox="0 0 20 20" fill="none">
        {path}
      </svg>
    </span>
  );
};

export default TypeIcon;
